import baseApi from './baseApi'
import {convertToUrlParams} from 'utils'

const queueApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getQueueHealth: build.query({
            query: () => ({
                url: 'queues/health',
                method: 'GET',
            }),
            transformResponse: (res) => res,
        }),
        getQueueStats: build.query({
            query: () => ({
                url: 'queues/stats',
                method: 'GET',
            }),
            transformResponse: (res) => res,
            providesTags: ['Queue'],
        }),
        getQueueJobs: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `queues/jobs${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result, error, arg) => {
                const parsedQuery =
                    typeof arg === 'string'
                        ? Object.fromEntries(new URLSearchParams(arg))
                        : arg || {}
                return [{type: 'Queue', id: `${parsedQuery.queueName}-jobs`}]
            },
        }),
        pauseQueue: build.mutation({
            query: (queueName) => ({
                url: `queues/${queueName}/pause`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Queue'],
        }),
        resumeQueue: build.mutation({
            query: (queueName) => ({
                url: `queues/${queueName}/resume`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Queue'],
        }),
        clearQueue: build.mutation({
            query: (queueName) => ({
                url: `queues/${queueName}/clear`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Queue'],
        }),
        cancelJob: build.mutation({
            query: ({queueName, jobId}) => ({
                url: `queues/jobs/${queueName}/${jobId}`,
                method: 'DELETE',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Queue'],
        }),
        retryJob: build.mutation({
            query: ({queueName, jobId}) => ({
                url: `queues/jobs/${queueName}/${jobId}/retry`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Queue'],
        }),
    }),
    overrideExisting: false,
})

export default queueApi

export const {
    useGetQueueHealthQuery,
    useGetQueueStatsQuery,
    useGetQueueJobsQuery,
    usePauseQueueMutation,
    useResumeQueueMutation,
    useClearQueueMutation,
    useCancelJobMutation,
    useRetryJobMutation,
} = queueApi
